import { createMetricsFactory } from 'metrics-js';

/**
 * Creates a metrics factory for the customer portal app.
 * @description Metrics are used to track things like performance, button clicks etc. but
 * without the context of session context.
 */
export const Metrics = createMetricsFactory('customer-portal-app');